import { Separator, Skeleton } from "@/components/ui";
import { Fragment } from "react/jsx-runtime";

export const CareTeamMemberSkeleton = () => {
  return (
    <div
      className="flex flex-col gap-2 px-3 py-2"
      data-testid="care-team-member-skeleton"
    >
      {[...Array(3)].map((_, index) => (
        //  biome-ignore lint/suspicious/noArrayIndexKey: unneeded for loading skeleton
        <Fragment key={`surgical-history-skeleton-${index}`}>
          <div className="flex flex-row gap-4">
            <Skeleton className="h-10 w-1/2" />
            <Skeleton className="h-10 w-1/2" />
          </div>
          <Separator />
        </Fragment>
      ))}
    </div>
  );
};
